<template>
<div :style="{marginBottom : '60' + 'px'}">   

<nav  class="navbar navbar-expand-lg fixed-top navbar-light" style="background-color: navy">  
<span class="badge badge-light mr-3 logo1"><strong>STUDIO RETAIL</strong></span> 

 
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#main_navbar" >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div  class="collapse navbar-collapse" id="main_navbar">
    <ul  class="navbar-nav mr-auto" >

      <li v-if="company.Id > 0 && isAdmin == 1" class="nav-item dropdown" >
        <a  style="color: white" v-bind:class="{ disabled: logoutBtn==1 }" class="nav-link dropdown-toggle" href="#" id="navbardrop1" data-toggle="dropdown">          
          <i style="color:#FFCC00" class='fas fa-chalkboard-teacher mr-1'></i>
          BACK OFFICE
        </a>
        <div class="dropdown-menu border border-info">

          <h6 style="color:green;font-size: large;" class="dropdown-header border border-primary"><strong>MAGAZZINO</strong></h6>
            <a v-bind:class="{ disabled: isAdmin==0 && !setMenuItem(route) }"  class="dropdown-item" :key="'mag_'+index" v-for="(route,index) in boRoutes1">
              <router-link style="color:black" :to="route" v-if="route.meta.visible==true"  ><i class="mr-3" v-bind:style="{color:'royalblue' ,fontSize:'18px'}" v-bind:class="route.meta.icon"></i> {{route.meta.name}}</router-link>
            </a>
          
          <h6 style="color:green;font-size: large;" class="dropdown-header  border border-primary"><strong>ORDINI FORNITORE</strong></h6>
            <button v-bind:class="{ disabled: isAdmin==0 && !setMenuItem(route)}"  class="dropdown-item" :key="'ord_'+index" v-for="(route,index) in boRoutes2">
              <router-link style="color:black" :to="route" v-if="route.meta.visible == true "  ><i class="mr-3" v-bind:style="{color:'royalblue',fontSize:'18px'}" v-bind:class="route.meta.icon"></i> {{route.meta.name}}</router-link>
              <div v-if="route.meta.divider" class="dropdown-divider"></div>
            </button>

            <h6 style="color:green;font-size: large;" class="dropdown-header  border border-primary"><strong>VENDITE</strong></h6>
            <button v-bind:class="{ disabled: isAdmin==0 && !setMenuItem(route)}"  class="dropdown-item" :key="'sal_'+index" v-for="(route,index) in boRoutes3">
              <router-link style="color:black" :to="route" v-if="route.meta.visible == true"  ><i class="mr-3" v-bind:style="{color:'royalblue',fontSize:'18px'}" v-bind:class="route.meta.icon"></i> {{route.meta.name}}</router-link>
            </button> 
           


        </div>
       
      </li>
      
      <li class="nav-item dropdown">
      <a style="color: white" v-bind:class="{ disabled: logoutBtn==1 }" class="nav-link dropdown-toggle " href="#" id="navbardrop2" data-toggle="dropdown">
        <i style="color: yellow" class='fas fa-laptop-code mr-1'></i>
        FRONT OFFICE
      </a>
      <div class="dropdown-menu border border-info">            
        <h6 style="color:green;font-size: large;" class="dropdown-header  border border-primary"><strong>VENDITA</strong></h6>
        
        <a class="dropdown-item" v-bind:class="{ disabled: isAdmin==0 && !setMenuItem(route)}" :key="'sales_' + index" v-for="(route,index) in foRoutes1">
          <router-link  style="color:black" :to="route" v-if="route.meta.visible==true" ><i class="mr-3" v-bind:style="{color:'royalblue',fontSize:'18px'}" v-bind:class="route.meta.icon" ></i>{{route.meta.name}}</router-link>
          <div v-if="route.meta.divider" class="dropdown-divider"></div>
        </a>
        <h6 style="color:green;font-size: large;" class="dropdown-header  border border-primary"><strong>TRASFERIMENTO</strong></h6>
        <a class="dropdown-item" v-bind:class="{ disabled: isAdmin==0 && !setMenuItem(route)}" :key="'stock_mov__'+ index" v-for="(route,index) in foRoutes2">
          <router-link  style="color:black" :to="route" v-if="route.meta.visible==true" ><i class="mr-3" v-bind:style="{color:'royalblue',fontSize:'18px'}" v-bind:class="route.meta.icon" ></i>{{route.meta.name}}</router-link>
          <div v-if="route.meta.divider" class="dropdown-divider"></div>
        </a>
        <h6 style="color:green;font-size: large;" class="dropdown-header  border border-primary"><strong>STOCK</strong></h6>
        <a class="dropdown-item" v-bind:class="{ disabled: isAdmin==0 && !setMenuItem(route)}" :key="'stock_manag_' + index" v-for="(route,index) in foRoutes3">
          <router-link  style="color:black" :to="route" v-if="route.meta.visible==true" ><i class="mr-3" v-bind:style="{color:'royalblue',fontSize:'18px'}" v-bind:class="route.meta.icon" ></i>{{route.meta.name}}</router-link>
          <div v-if="route.meta.divider" class="dropdown-divider"></div>
        </a>
        <h6 style="color:green;font-size: large;" class="dropdown-header  border border-primary"><strong>LISTINO</strong></h6>
        <a class="dropdown-item" v-bind:class="{ disabled: isAdmin==0 && !setMenuItem(route)}" :key="'price_list_'+index" v-for="(route,index) in foRoutes4">
          <router-link  style="color:black" :to="route" v-if="route.meta.visible==true" ><i class="mr-3" v-bind:style="{color:'royalblue',fontSize:'18px'}" v-bind:class="route.meta.icon" ></i>{{route.meta.name}}</router-link>
          <div v-if="route.meta.divider" class="dropdown-divider"></div>
        </a>
        <h6 style="color:green;font-size: large;" class="dropdown-header  border border-primary"><strong>IMPORT</strong></h6>
        <a class="dropdown-item" v-bind:class="{ disabled: isAdmin==0 && !setMenuItem(route)}" :key="'import_'+index" v-for="(route,index) in foRoutes5">
          <router-link  style="color:black" :to="route" v-if="route.meta.visible==true" ><i class="mr-3" v-bind:style="{color:'royalblue',fontSize:'18px'}" v-bind:class="route.meta.icon" ></i>{{route.meta.name}}</router-link>
          <div v-if="route.meta.divider" class="dropdown-divider"></div>
        </a>
       


      </div>  
      </li> 

      <!--   ATTENTION PLEASE    -->
      <li v-if="company.Id > 0" class="nav-item dropdown">
      <a style="color: white" v-bind:class="{ disabled: logoutBtn == 1  }" class="nav-link dropdown-toggle " href="#" id="navbardrop3" data-toggle="dropdown">
        <i style="color: green" class='fas fa-industry mr-1'></i>
        REPORT
      </a>

      <div class="dropdown-menu border border-info">   
        <a class="dropdown-item" v-bind:class="{ disabled: isAdmin==0 &&  !setMenuItem(route) }" :key="'cash_'+index" v-for="(route,index) in rpRoutes1">
          <router-link  style="color:black" :to="route" v-if="route.meta.visible==true" ><i class="mr-3" v-bind:style="{color:'royalblue',fontSize:'18px'}" v-bind:class="route.meta.icon" ></i>{{route.meta.name}}</router-link>
          <div v-if="route.meta.divider" class="dropdown-divider"></div>
        </a>
        <h6 style="color:green;font-size: large;" class="dropdown-header  border border-primary"><strong>SELL OUT</strong></h6>         
        
        <a   class="dropdown-item" v-bind:class="{ disabled: isAdmin==0 && !setMenuItem(route) }" :key="'sellout_'+index" v-for="(route,index) in rpRoutes2">
          <router-link  style="color:black" :to="route" v-if="company.Id == 57  && route.meta.visible==true" ><i class="mr-3" v-bind:style="{color:route.meta.color,fontSize:'18px'}" v-bind:class="route.meta.icon" ></i>{{route.meta.name}}</router-link>
          <router-link  style="color:black" :to="route" v-if="company.Id != 57  && route.meta.visible==true && route.meta.component==true" ><i class="mr-3" v-bind:style="{color:route.meta.color,fontSize:'18px'}" v-bind:class="route.meta.icon" ></i>{{route.meta.name}}</router-link>
          <div v-if="route.meta.divider" class="dropdown-divider"></div>
        </a>

        <h6 style="color:green;font-size: large;" class="dropdown-header  border border-primary"><strong>ANALISI VENDITE</strong></h6>         
        <a class="dropdown-item" v-bind:class="{ disabled: isAdmin==0 && !setMenuItem(route) }" :key="'analisi1_'+index" v-for="(route,index) in rpRoutes3">
          <router-link  style="color:black" :to="route" v-if="route.meta.visible==true" ><i class="mr-3" v-bind:style="{color:'royalblue',fontSize:'18px'}" v-bind:class="route.meta.icon" ></i>{{route.meta.name}}</router-link>
          <div v-if="route.meta.divider" class="dropdown-divider"></div>
        </a>

        <h6 style="color:green;font-size: large;" class="dropdown-header  border border-primary"><strong>ANALISI STOCK</strong></h6>         
        <a class="dropdown-item" v-bind:class="{ disabled: isAdmin==0 && !setMenuItem(route) }" :key="'analisi2_'+index" v-for="(route,index) in rpRoutes4">

          <router-link style="color:black" :to="route" v-if="route.meta.visible==true" ><i class="mr-3" v-bind:style="{color:'royalblue',fontSize:'18px'}" v-bind:class="route.meta.icon" ></i>{{route.meta.name}}</router-link>
          <div v-else class="dropdown-divider"></div>

        </a>
       
      </div>  
      </li>  


      <li class="nav-item dropdown">
      <a style="color: white" v-bind:class="{ disabled: logoutBtn == 1  }" class="nav-link dropdown-toggle " href="#" id="navbardrop3" data-toggle="dropdown">
        <i class='fas fa-cogs mr-1'></i>
        MARKET
      </a>
      <div class="dropdown-menu border border-info">  
        
        <a class="dropdown-item" v-bind:class="{ disabled : isAdmin == 0 && !setMenuItem(route) }" :key="'user_'+index" v-for="(route,index) in mkRoutes1">
          <router-link  style="color:black" :to="route" v-if="route.meta.visible==true" ><i class="mr-3" v-bind:style="{color:'royalblue',fontSize:'18px'}" v-bind:class="route.meta.icon" ></i>{{route.meta.name}}</router-link>
          <div v-if="route.meta.divider" class="dropdown-divider"></div>
        </a>

       

      </div>  

      </li>  

      <li class="nav-item dropdown">
      <a style="color: white" v-bind:class="{ disabled: logoutBtn == 1  }" class="nav-link dropdown-toggle " href="#" id="navbardrop3" data-toggle="dropdown">
        <i class='fas fa-cogs mr-1'></i>
        ADMIN
      </a>
      <div class="dropdown-menu border border-info">  
        
        <a class="dropdown-item" v-bind:class="{ disabled : isAdmin == 0 && !setMenuItem(route) }" :key="'user_'+index" v-for="(route,index) in adRoutes1">
          <router-link  style="color:black" :to="route" v-if="route.meta.visible==true" ><i class="mr-3" v-bind:style="{color:'royalblue',fontSize:'18px'}" v-bind:class="route.meta.icon" ></i>{{route.meta.name}}</router-link>
          <div v-if="route.meta.divider" class="dropdown-divider"></div>
        </a>
  
      </div>  

      </li>  
      
            
    </ul>
     
    <div v-if="items.length>0" class="dropdown">
      <a class="btn btn-info dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false">
        <i style="color:white" class='fas fa-download mr-2'></i>
        DOWNLOAD LINK 
      </a>

      <div class="dropdown-menu">
        <a :key="index" v-for="(item,index) in items" @click="download(item.feed_url)" class="dropdown-item" href="#">
          <i style="color:blue;font-size:20px " class='fas fa-file-download mr-2'></i>
          {{item.mp}}</a>
      </div>

    </div>

    <ul class="navbar-nav md-auto mr-2" >
    
      <li class="nav-item dropdown">
        
        <a style="color: white" class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false">
          <span  style="color:red" class="far fa-user mr-2" aria-hidden="true"></span>
          <strong style="color:yellow">{{currentUser}}</strong>
        </a>

        <div class="dropdown-menu">
          <a class="dropdown-item" @click="setModalPassword()" href="#"  data-toggle="modal" data-target="#staticChangePassWord">
            <router-link  style="color:black" :to="'password'" ><i class="mr-3" v-bind:style="{color:'black'}" v-bind:class="'fas fa-user-edit'"></i>Cambio password</router-link>
          </a>
        
        </div>
      
      
      </li>  
    
    </ul>  

    <span style="color:yellow" class="navbar-text ml-5">
      <i class="fas fa-store mr-2" aria-hidden="true"></i>
      <strong >{{store.toUpperCase()}}</strong>
    </span>
    

    <form class="form-inline my-2 my-lg-0">
      <button  :disabled="logoutBtn==1" id="logout_btn"   @click="exitBox()" class="btn logout ml-5" type="button">LOGOUT
        <span class="fas fa-sign-out-alt"></span>
      </button>
    </form>

  </div>

 
</nav>

<!--<changePassword></changePassword>-->
<stores v-if="storeList" @close="storeList=false"></stores>
<!-- EXIT BOX -->
  <div class="modal" id="exitBox" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal" role="document">
    <div class="modal-content">
      <div style="background-color: #3333FF" class="modal-header">
        <h5  style="color:white" class="modal-title">
           <i class="fas fa-sign-out-alt mr-2" aria-hidden="true"></i>
          <strong>LOGOUT</strong></h5>
        
      </div>
      <div class="modal-body">
        <p ><strong>Si desidera uscire da <h4 class="text-center mt-3"><span  style="color:#3333FF">STUDIO RETAIL</span> ?</h4>  </strong> </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary float-left" data-dismiss="modal">No</button>
        <button @click="logout()" type="button" data-dismiss="modal" class="btn btn-primary">Si</button>
        
      </div>
    </div>
  </div>
  </div>
  <!-- EXIT BOX -->




</div>
</template>

<script>

import { mapGetters }  from 'vuex'; 
import api             from '@/api'
import stores          from './../views/Store.vue'

export default {
  name: '',
  components: {stores
    
  },
   data () {
    return {
      items : [],
      storeList : false
    }
   },

/*
   filters: {
      currencydecimal (value) {
      return value.toFixed(2)
  }
  },  

*/

 computed: {
    ...mapGetters(['currentUser','store','logoutBtn','isAdmin','userMenu','company']), 

       boRoutes1 : function()
       {  
          const menuId = 'bo1'
          return this.$router.options.routes.filter(item => item.meta.menu == menuId)        
       },
       boRoutes2 : function()
       { 
         const menuId = 'bo2'        
         return  this.$router.options.routes.filter(item => item.meta.menu == menuId)
       },
       boRoutes3 : function()
       {
          const menuId = 'bo3'
          return  this.$router.options.routes.filter(item => item.meta.menu == menuId)          
       }, 
    
       foRoutes1 : function()
       {
          const menuId = 'fo1'
          return  this.$router.options.routes.filter(item => item.meta.menu == menuId)          
       }, 
       foRoutes2 : function()
       {
          const menuId = 'fo2'
          return  this.$router.options.routes.filter(item => item.meta.menu == menuId)          
       }, 
       foRoutes3 : function()
       {
          const menuId = 'fo3'
          return  this.$router.options.routes.filter(item => item.meta.menu == menuId)          
       }, 
       foRoutes4 : function()
       {
          const menuId = 'fo4'
          return  this.$router.options.routes.filter(item => item.meta.menu == menuId)          
       }, 
       foRoutes5 : function()
       {
          const menuId = 'fo5'
          return  this.$router.options.routes.filter(item => item.meta.menu == menuId)          
       }, 



   
    
       rpRoutes1 : function()
       { 
         const menuId = 'rp1'
         return  this.$router.options.routes.filter(item => item.meta.menu == menuId)
       },
       rpRoutes2 : function()
       { 
         const menuId = 'rp2'
         return  this.$router.options.routes.filter(item => item.meta.menu == menuId)
       },
       rpRoutes3 : function()
       { 
         const menuId = 'rp3'
         return  this.$router.options.routes.filter(item => item.meta.menu == menuId)
       }, 
       rpRoutes4 : function()
       { 
         const menuId = 'rp4'
         return  this.$router.options.routes.filter(item => item.meta.menu == menuId)
       }, 
      
       mkRoutes1 : function()
       {   const menuId = 'mk1'
          return  this.$router.options.routes.filter(item => item.meta.menu == menuId)
         
       },
       adRoutes1 : function()
       {   const menuId = 'ad1'
          return  this.$router.options.routes.filter(item => item.meta.menu == menuId)
         
       },
    
     
     
      
     
  },

 
  mounted(){
    
   
   
    this.storeList = true

    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    })
    this.getData()

    
    
    },
  methods:{
    async getData()
    {
      const sp       = {'sp'        : 'spFeedUrl'}
      const data     = {'companyId' : this.company.Id}
      const json     = Object.assign(data, sp)
      await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]   
            }
           else if(res.status==500)
           {
               
                /*
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                */
                
                    
           } 
           else
            {
                
              /*
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                */
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.bt_spinner = false
        });


    },

    
    download(url)
    {
      window.location.href = url;
    },
    setModalPassword()
    {
      $('#staticChangePassWord').on('shown.bs.modal', function (event) {
      $('#inputPassword').val('');
      $('#inputPassword1').val('');
      $('#inputPassword2').val('');
      $('#inputPassword').trigger('focus');
     
    })
    },
    logout()
    {
      this.$store.commit('AUTH_STATUS_CHANGE',{isLoggedIn : false}) 
      this.$store.commit('AUTH_STORE_ID',{storeId : 0})
      this.$router.push('/login')
    },
    
    setMenuItem(menu)
    {
      
      let menuItem = false
      //console.log(menu)
      this.userMenu.forEach(item => 
      {                   
        if(menu.name == item.component )
        {      
          menuItem = true
        }
        
      }) 
      
      return menuItem
    },
    exitBox()
    {
       $('#exitBox').modal({keyboard: false,backdrop:'static'});
      //this.$router.push('/login')
    }
  }
  
}
</script>

<style scoped>

.logo1
{
  height          :  30px;
  background-color : rgb(3, 110, 3);
  color            : white;
}
.dropdown-header{
  color            :rgb(3, 3, 90)!important;
  background-color : rgb(240, 234, 234);
}

a {
  
  text-decoration : none;
  font-family     : "Roboto Condensed";  
  
}


.navbar-toggler {
  background-color  : white;
  color             :grey;
}

#nav {
  padding: 30px;
}

#nav a.router-link-exact-active {
  color: red;
  

}

.text-link 
{
    color           : inherit;
    text-decoration : inherit;
}
    
#exitBox .modal-footer {  
  justify-content: space-between;  
}
.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}

.badge-light
{
  font-size: 20px;
}


.logout{
  color:black;
  background-color: white;
}


.dropdown-item:hover {
  background-color:rgb(228, 229, 234);
}
.border-primary
{
 
  border-color: rgb(17, 3, 57) !important;
}


</style>

